import s from './styles.module.scss';

const ControlButtonLabel = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => (
  <div className={s['dropdown-btn-wrapper']}>
    <p className={s.title}>{title}</p>
    <p className={s.subtitle}>{subtitle}</p>
  </div>
);

export default ControlButtonLabel;
